<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'AuditLog',
  },
})

const page = {
  groupTitle: 'Administrasi',
  icon: 'ri-file-search-line',
  color: 'error',
  title: 'Audit Log',
  description: 'Menelusuri siapa mengubah apa dan kapan, di seluruh modul.',
  purpose: 'Panduan membaca Audit Log — catatan otomatis setiap perubahan data penting di QUALIVA.',
  concept: [
    {
      icon: 'ri-history-line',
      title: 'Tercatat Otomatis, Tidak Bisa Dimatikan',
      text: 'Setiap kali data penting dibuat, diubah, atau dihapus, sistem otomatis mencatatnya di sini — Anda tidak perlu (dan tidak bisa) mengaktifkan/menonaktifkan pencatatan ini secara manual.',
    },
    {
      icon: 'ri-lock-line',
      title: 'Tidak Bisa Diedit atau Dihapus',
      text: 'Audit Log bersifat baca-saja untuk semua orang, termasuk super-admin — ini menjaga jejaknya tetap bisa dipercaya sebagai bukti audit.',
    },
  ],
  steps: [
    { title: 'Buka menu Audit Log', detail: 'Lihat daftar aktivitas terbaru di seluruh sistem.' },
    { title: 'Gunakan filter untuk mempersempit pencarian', detail: 'Bisa filter berdasarkan User, jenis data (Model), atau rentang tanggal.' },
    { title: 'Klik satu baris untuk melihat detail perubahan', detail: 'Menampilkan nilai sebelum dan sesudah perubahan, kalau ada.' },
  ],
  tips: [
    'Cek Audit Log secara rutin untuk aktivitas mencurigakan, terutama pada data sensitif seperti Role & Permission.',
    'Saat sesi Impersonate berlangsung, aktivitas tetap tercatat atas nama admin asli, dengan penanda tambahan siapa yang sedang ditiru.',
  ],
  faq: [
    { q: 'Apakah aktivitas login/logout tercatat di sini?', a: 'Ya — login dan logout termasuk aktivitas yang dicatat di Audit Log.' },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
